import React from 'react';
import Modal from 'components/Common/Modal';

import s from './UnsupportedBrowserInterrupt.css';

export default () => (
  <Modal
    open
    title={<div className={s.title}>Your Browser is Out of Date!</div>}
    showCloseButton={false}
  >
    <div className={s.container}>
      Uh Oh, it looks like you&apos;re using an out-of-date browser! To get the
      most out of SchooLinks features, and to stay safe and secure while using
      all sites, you will need to use a different browser.
      <br />
      <br />
      We suggest you download the latest version of{' '}
      <a
        className={s.link}
        href="https://www.google.com/chrome/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Google Chrome
      </a>{' '}
      and then come right back here!
      <a
        className={s.actionButton}
        href="https://www.google.com/chrome/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Get Chrome
      </a>
    </div>
  </Modal>
);
